export interface MetricStripItem {
	label: string;
	value: string;
	detail?: string;
	tone?: "neutral" | "attention" | "success";
}

export function MetricStrip({ items }: { items: MetricStripItem[] }) {
	return (
		<section className="grid gap-px overflow-hidden rounded-2xl border border-stone-200 bg-stone-200 shadow-sm sm:grid-cols-2 xl:grid-flow-col xl:auto-cols-fr xl:grid-cols-none">
			{items.map((item) => (
				<div
					key={item.label}
					className={`min-w-0 bg-white px-4 py-3 ${
						items.length % 2 === 1 ? "last:sm:col-span-2 last:xl:col-span-1" : ""
					}`}
				>
					<p className="truncate text-[11px] font-medium text-stone-500">{item.label}</p>
					<p
						className={`mt-0.5 whitespace-nowrap text-lg font-semibold tabular-nums tracking-[-0.025em] ${
							item.tone === "attention"
								? "text-amber-700"
								: item.tone === "success"
									? "text-emerald-800"
									: "text-stone-950"
						}`}
					>
						{item.value}
					</p>
					{item.detail && (
						<p className="mt-0.5 truncate text-[11px] text-stone-500">{item.detail}</p>
					)}
				</div>
			))}
		</section>
	);
}
